import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Paging } from '@app/model/paging';
import { Product } from '@app/model/product';
import { Observable, finalize, map } from 'rxjs';
import { LoaderService } from '../loader/loader.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  API_BASE_PATH = environment.API_URL;

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService
  ) { }

  //Get All 
  getAllSellerProducts(paging: Paging): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.API_BASE_PATH}seller-product` + '?paging=' + paging).pipe(
      finalize(() => {
      })
    );
  }

  getTopSellerProducts(): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.API_BASE_PATH}seller-top-product`).pipe(
      finalize(() => {
      })
    );
  }

  // Get by UUID
  getSellerProductInfoByUUId(UUID: any): Observable<Product> {
    return this.http.get<Product>(`${this.API_BASE_PATH}${UUID}/seller-product`);
  }
// Get by UUID and ID
  getSellerProductByUUID_Id(id: any, UUID:any): Observable<Product> {
    this.loaderService.show();

    return this.http.get<Product>(`${this.API_BASE_PATH}${UUID}/seller-product/${id}`).pipe(
      finalize(() => {
        this.loaderService.hide();
      })
    );
  }

  resolveProductOwnerBySlug(slug: string, productId: string): Observable<any> {
    const paging = new Paging();
    paging.itemsPerPage = 1000;
    paging.pageNumber = 1;
    paging.pagination = 1;
    paging.isAllWords = true;
    return this.getAllSellerProducts(paging).pipe(
      map((result: any) => {
        const products = Array.isArray(result) ? result : result?.data || [];
        const normalizedSlug = this.toSlug(slug);
        const product = products.find((item: any) =>
          String(item.sellProductInfoId) === String(productId) &&
          this.toSlug(item.sellProductTitle) === normalizedSlug
        );
        return product || null;
      })
    );
  }

  private toSlug(value: string | null | undefined): string {
    return (value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Add by UUID
  addSellerProductByUUId(UUID: any, formData: FormData) {
    return this.http.post(`${this.API_BASE_PATH}${UUID}/seller-product`, formData);
  }
  
  // Update by UUID ad data exiting ID
  updateSellerImageByUUId(UUId: any, formData: FormData): Observable<Product> {
    return this.http.patch<Product>(`${this.API_BASE_PATH}${UUId}/seller-product`, formData);
  }

  // Delete by UUID and ID
  deleteSellerProductByUUID_Id(UUID: any, id: any) {
    return this.http.delete(`${this.API_BASE_PATH}${UUID}/seller-product/${id}`);
  }
  
  // Search products by sellProductTitle, category, subCategory, country, state, district
  //searchProducts(data: { sellProductTitle:string, sellProductCategory: string, sellProductSubCategory:string, sellProductCountry:string, sellProductState:string,sellProductDistrict:string}) {
  //  return this.http.post(`${this.API_BASE_PATH}search-products`, data, {headers: { 'Content-Type': 'application/json' }});
  //}

  searchProductsByNameId(name: any, category: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-product/${name}/${category}` + '?paging=' + paging);
  } 
  
  searchByProducts(name: any, location: any, category: any, paging:Paging): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}search-product/${name}/${location}/${category}` + '?paging=' + paging);
  } 

  // Not used -- confirm and delete later
  findByTitle(name: any, paging:Paging): Observable<Product[]> {
    return this.http.get<Product[]>(`${this.API_BASE_PATH}search-product/${name}` + '?paging=' + paging);
  }
  
  // Common API for filter and search 
  filterProduct(paging:Paging, filterCriteria: any): Observable<any> {
    return this.http.get<Product>(`${this.API_BASE_PATH}filter-product/${filterCriteria.name}/${filterCriteria.category}/${filterCriteria.subCategory}/${filterCriteria.country}/${filterCriteria.state}/${filterCriteria.district}` +'?paging=' + paging);
  }
}
